import { Eye } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

// Hotspot positions are percentages of the facility-layout image. Mirrors
// the values used in BookingForm/CourtSelection, so dialogs match the
// real-world layout that customers see elsewhere on the site. Court 5 is
// present in the image but not bookable yet — the overlay marks it as
// "Soon to Open".
const HOTSPOTS = {
  "Court 1": { top: "78%", left: "40%", width: "44%", height: "13%" },
  "Court 2": { top: "40%", left: "39%", width: "23%", height: "31%" },
  "Court 3": { top: "40%", left: "64%", width: "23%", height: "31%" },
  "Court 4": { top: "10%", left: "40%", width: "44%", height: "15%" },
  "Court 5": { top: "10%", left: "13%", width: "23%", height: "42%" },
};

const FACILITY_IMG =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_court-reserve-54/artifacts/daewz7cf_kawit%20pickleball%20court_website.png";

/**
 * Reusable popup that shows the Assenda facility layout with one or more
 * courts highlighted in brand green. Used by the Special Rental option
 * cards so customers can visualise exactly which courts are included.
 */
const CourtLayoutDialog = ({ open, onOpenChange, title, courts = [] }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="court-layout-dialog"
      className="max-w-sm bg-[#0a0a0a] text-white"
    >
      <DialogHeader>
        <DialogTitle className="text-lg font-black tracking-tight flex items-center gap-2">
          <Eye size={18} className="text-[#8cc63f]" />
          {title}
        </DialogTitle>
      </DialogHeader>

      <div className="relative mx-auto" style={{ maxWidth: "320px" }}>
        <img
          src={FACILITY_IMG}
          alt="Assenda facility layout"
          className="w-full h-auto rounded-md block"
        />
        {courts.map((name) => {
          const h = HOTSPOTS[name];
          if (!h) return null;
          return (
            <div
              key={name}
              data-testid={`layout-highlight-${name.toLowerCase().replace(/\s+/g, "-")}`}
              className="absolute rounded-sm border-2 border-[#8cc63f] bg-[#8cc63f]/35 shadow-[0_0_18px_rgba(140,198,63,0.6)] animate-pulse"
              style={{
                top: h.top,
                left: h.left,
                width: h.width,
                height: h.height,
              }}
              aria-label={`${name} highlighted`}
            />
          );
        })}
      </div>

      <p className="text-xs text-[#a1a1aa] text-center mt-2">
        {courts.length > 0 ? (
          <>
            Highlighted in <span className="text-[#8cc63f] font-semibold">green</span> ·{" "}
            {courts.join(" + ")}
          </>
        ) : (
          "Assenda facility — 5 pickleball courts"
        )}
      </p>
    </DialogContent>
  </Dialog>
);

export default CourtLayoutDialog;
